import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FrDateInput } from "@/components/FrDateInput";

export const EMPTY_CLIENT = { last_name: "", first_name: "", birth_date: "", address: "", nir: "", mutuelle: "", amc_number: "", member_number: "" };
export const CLIENT_LABELS = { last_name: "Nom", first_name: "Prénom", birth_date: "Date de naissance", address: "Adresse complète", nir: "N° de sécurité sociale (NIR)", mutuelle: "Mutuelle", amc_number: "N° AMC", member_number: "N° adhérent / contrat" };

const Flag = ({ on }) => on ? <span className="ml-2 text-[10px] font-bold uppercase tracking-wide text-orange-700 bg-orange-50 border border-orange-200 rounded px-1.5 py-0.5">À vérifier</span> : null;

// Champs de la fiche « Nouveau client » : nom + prénom obligatoires, le reste complétable plus tard. `flags` = champs proposés par l'OCR à vérifier.
export function ClientForm({ value, onChange, flags = {}, prefix = "client" }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const text = (k, extra = {}) => (
    <div key={k}><Label>{CLIENT_LABELS[k]}<Flag on={flags[k]} /></Label>
      <Input data-testid={`${prefix}-${k}`} value={value[k] || ""} onChange={(e) => set(k, e.target.value)} className="mt-1 h-12 text-base" {...extra} /></div>
  );
  return (
    <div className="space-y-3">
      {text("last_name", { autoCapitalize: "characters", placeholder: "Obligatoire" })}
      {text("first_name", { placeholder: "Obligatoire" })}
      <div><Label>{CLIENT_LABELS.birth_date}<Flag on={flags.birth_date} /></Label><FrDateInput value={value.birth_date || ""} onChange={(v) => set("birth_date", v)} mode="birth" testid={`${prefix}-birth_date`} className="mt-1" /></div>
      {text("address", { placeholder: "N°, rue, code postal, commune" })}
      {text("nir", { inputMode: "numeric", placeholder: "13 chiffres + clé" })}
      {text("mutuelle", { placeholder: "Organisme complémentaire" })}
      {text("amc_number", { inputMode: "numeric" })}
      {text("member_number")}
    </div>
  );
}
